import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Skeleton,
  Typography,
} from "@mui/material";
import React from "react";
import { Colours } from "../assets/global/Theme-variable";
import { DataGridContext } from "../context/DataGridContext";
import { useNavigate } from "react-router-dom";
import MainButton from "./Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CiBeerMugFull } from "react-icons/ci";
import { useUserState } from "../context/UserContext";

export default function StatCard({ stat }) {
  const navigate = useNavigate();
  const { loading } = React.useContext(DataGridContext);
  const userPermission = useUserState();
  return (
    <Card
      elevation={0}
      sx={{
        width: "25%",
        height: "auto",
        // aspectRatio: 3 / 1,
        // backgroundColor: "#DFF2F8",
        // border: "1px solid #f0f0f0",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "space-between",
        // margin: 2,
        padding: 2,
        borderRadius: 1,
        // boxShadow: 1,

        background: "#f8f8f8",
      }}
    >
      <CardContent
        sx={{
          padding: 0,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            borderRadius: "50%",
            background: "#ffffff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 40,
            width: 40,
            mr: 2,
            ml: 1,
          }}
        >
          <stat.icon size={stat.iconSize} color={Colours.gsblue} />
        </Box>
        <Typography component={"div"} sx={{ flexDirection: "column" }}>
          {userPermission?.permissions?.length === 0 ? (
            <></>
          ) : stat.stat !== null && !loading ? (
            <Box
              sx={{
                fontSize: 30,
                textAlign: "left",
                userSelect: "none",
                fontWeight: "500",
                lineHeight: "normal",

                // mb: -0.5,
              }}
              color={Colours.gsblue}

              // gutterBottom
            >
              {stat.stat}
            </Box>
          ) : loading ? (
            <Skeleton
              animation="wave"
              height={40}
              sx={{ bgcolor: Colours.white }}
            />
          ) : (
            <Box
              sx={{
                fontSize: 30,
                textAlign: "left",
                userSelect: "none",
                fontWeight: "500",
                lineHeight: "normal",

                // mb: -0.5,
              }}
              color={Colours.gsblue}

              // gutterBottom
            >
              -
            </Box>
          )}
          <Box
            sx={{
              fontSize: 14,
              paddingTop: 0,
              userSelect: "none",
              fontWeight: "500",
              lineHeight: "normal",
              color: Colours.darkGrey,
            }}
          >
            {stat.name}
          </Box>
        </Typography>
      </CardContent>
      <CardActions
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          justifySelf: "flex-end",
        }}
      >
        {userPermission?.permissions?.length === 0 ? (
          <></>
        ) : (
          <IconButton
            aria-label="go"
            size="small"
            onClick={() => navigate(`/${stat.url}`)}
          >
            <ArrowForwardIcon
              color={Colours.gsblue}
              size="10px"
              sx={{ color: Colours.gsblue }}
            />
          </IconButton>
        )}
      </CardActions>
    </Card>
  );
}
